"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.startConsoleCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logger_1 = require("../../logger");
var LogStatusForApi = (_a = {},
    _a[browser_core_1.ConsoleApiName.log] = logger_1.StatusType.info,
    _a[browser_core_1.ConsoleApiName.debug] = logger_1.StatusType.debug,
    _a[browser_core_1.ConsoleApiName.info] = logger_1.StatusType.info,
    _a[browser_core_1.ConsoleApiName.warn] = logger_1.StatusType.warn,
    _a[browser_core_1.ConsoleApiName.error] = logger_1.StatusType.error,
    _a);
function startConsoleCollection(configuration, sender) {
    var consoleObservable = (0, browser_core_1.initConsoleObservable)(configuration.forwardConsoleLogs);
    var consoleSubscription = consoleObservable.subscribe(reportConsoleLog);
    function reportConsoleLog(log) {
        var messageContext = {
            origin: browser_core_1.ErrorSource.CONSOLE,
        };
        if (log.api === browser_core_1.ConsoleApiName.error) {
            messageContext.error = {
                origin: browser_core_1.ErrorSource.CONSOLE,
                stack: log.stack,
            };
        }
        sender.sendToHttp(log.message, messageContext, LogStatusForApi[log.api]);
    }
    return {
        stop: function () {
            consoleSubscription.unsubscribe();
        },
    };
}
exports.startConsoleCollection = startConsoleCollection;
//# sourceMappingURL=consoleCollection.js.map